/**
 * Initialism for a camera name — "Left Blue Line" -> "LBL", "Right Rocker" -> "RR".
 *
 * Extracted verbatim from PlayerCameraFeedSelectionButton, which has used it for
 * the video player's camera feed buttons since before the clips table needed it.
 * Shared so the two surfaces cannot drift: an operator reading "LBL" in the
 * player and "LBL" in a clips row has to be seeing the same camera.
 *
 * Single-word names collapse to one letter ("Overhead" -> "O"), which is
 * inherent to an initialism. Pair this with the full name in a tooltip wherever
 * the short form is the only thing on screen.
 */
export const getAbbreviation = (name: string): string => {
  return name
    .split(' ')
    .map((word) => word[0]?.toUpperCase() || '')
    .join('');
};
